'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';

export function DealerPartnerHeroBanner() {
  return (
    <motion.section
      className='relative w-full rounded-xl md:mb-15 lg:mb-20 mb-6  overflow-hidden'
      initial='initial'
      animate='animate'
      variants={{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0, transition: { duration: 0.6 } } }}
    >
      <motion.div className='relative inset-0 w-full h-full z-0' aria-hidden>
        <Image
          src='/images/dealer-partner/dealer-partner-banner.png'
          alt='Dealer Network Hero'
          className='object-cover object-center'
          width={1360}
          height={460}
          priority
        />
        <div className='absolute inset-0  bg-[#463928B2]' />
      </motion.div>
      <div className='absolute inset-0 z-10 flex flex-col items-center justify-center py-16 md:py-24 text-center'>
        <motion.h2
          className='text-3xl md:text-[2.5rem] leading-[120%] font-bold text-white mb-5.5'
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.7 }}
        >
          ClovisClassics.com Dealer Network
        </motion.h2>
        <motion.p
          className='text-lg md:text-2xl leading-[150%] text-white/90 font-bold'
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.7 }}
        >
          Join now to grow your business
        </motion.p>
      </div>
    </motion.section>
  );
}
